import { render, staticRenderFns } from "./PuzzleList.vue?vue&type=template&id=266fc7fd&scoped=true"
import script from "./PuzzleList.vue?vue&type=script&lang=js"
export * from "./PuzzleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266fc7fd",
  null
  
)

export default component.exports